import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductConflict } from 'anchor-shared/lib/model/interface/productConflict';
import { CharterConflictRequest } from '../../../../../core/services/dao/vesselAvailabilityPreferencesDAO';
import * as moment from 'moment';

@Component({
  selector: 'app-admin-warning',
  templateUrl: './admin-warning-dialog.component.html',
  styleUrls: ['./admin-warning-dialog.component.scss'],
})
export class AdminWarningDialogComponent implements OnInit {
  confirmCharter: boolean;
  productConflicts: ProductConflict[];
  conflictRequest: CharterConflictRequest;
  product: Partial<ProductConflict>;
  conflictingTimesDisplay: String;

  constructor(
    private dialogRef: MatDialogRef<AdminWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      productConflict: ProductConflict[];
      conflictRequest: CharterConflictRequest;
    },
  ) {
    this.productConflicts = this.data.productConflict;
    this.conflictRequest = this.data.conflictRequest;
    this.conflictRequest.date = moment
      .utc(this.conflictRequest.date)
      .format('LL');
  }

  ngOnInit() {}

  responseYes(): void {
    this.confirmCharter = true;
    this.closeDialog();
  }

  responseNo(): void {
    this.confirmCharter = false;
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close(this.confirmCharter);
  }
}
